import { useMemo } from 'react';

import { Renewal, RenewalStatus } from '@/modules/Renewals/renewals.types';

const ALLOWED_STATUSES: RenewalStatus[] = [
  RenewalStatus.NEW,
  RenewalStatus.CANCELED,
  RenewalStatus.REQUESTED,
];

const useFilteredRenewals = (renewals?: Renewal[]): Renewal[] => {
  return useMemo(() => {
    if (!renewals) return [];
    return renewals.filter((renewal) => ALLOWED_STATUSES.includes(renewal.status));
  }, [renewals]);
};

export default useFilteredRenewals;
